import I18n from 'I18n';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Text } from 'foundations-components/components/Text';
import { View } from 'foundations-components/components/View';
import { FormLabel } from 'foundations-components/transitional/components/FormLabel';
import { Select } from 'foundations-components/transitional/components/Select';
import { Tab, Tabs } from 'foundations-components/transitional/components/Tabs';
import { getQueryParams } from 'pricing-pages-lib/utils/queryParamUtils';
import { useIsMobile } from 'pricing-pages-ui-components/hooks/useMedia';
import { useEffect, useId } from 'react';
import { useSetQueryParams } from '../../utils/urls/appQueryParamUtilsLegacy';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const NavItemTabs = ({
  tabs,
  selected,
  setSelected
}) => {
  const isMobile = useIsMobile();
  const dropdownId = useId();
  const setQueryParams = useSetQueryParams();
  useEffect(() => {
    const queryParams = getQueryParams();
    const tab = (Array.isArray(queryParams.tab) ? queryParams.tab : [queryParams.tab]).find(t => tabs.includes(t));

    // If tab is invalid or not set on initial render, update the query params to initial selected tab
    if (!tab) {
      setQueryParams({
        tab: selected
      });
      return;
    }

    // If multiple valid tabs provided on initial render, set to only the first valid one
    if (Array.isArray(queryParams.tab)) {
      setQueryParams({
        tab
      });
      setSelected(tab);
      return;
    }

    // Update the selected tab state based on the query param on initial render
    setSelected(tab);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  if (!tabs.length) return null;
  const handleTabChange = tab => {
    if (tab !== selected) {
      setQueryParams({
        tab
      });
      setSelected(tab);
    }
  };
  if (isMobile) {
    return /*#__PURE__*/_jsxs(View, {
      marginBlockEnd: "800",
      children: [/*#__PURE__*/_jsx(FormLabel, {
        htmlFor: dropdownId,
        children: /*#__PURE__*/_jsx(Text, {
          typography: "heading-50",
          marginBlockEnd: "200",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "pricingPage.pages.hubspot-credits.unlockAI.tabLabel"
          })
        })
      }), /*#__PURE__*/_jsx(Select, {
        id: dropdownId,
        searchable: false,
        onChange: evt => {
          evt.preventDefault();
          handleTabChange(evt.currentTarget.value);
        },
        value: selected,
        options: tabs.map(tab => {
          return {
            value: tab,
            text: I18n.text(`pricingPage.pages.products.tabs.${tab}.tabTitle`)
          };
        })
      })]
    });
  }
  return (
    /*#__PURE__*/
    // For some reason, Tabs won't automatically render overflow dropdown when container is >99.6% width
    // using 98.3 so when screen resizes there's no overflow of tabs with cardWrapper
    _jsx(View, {
      inlineSize: "98.3%",
      marginInline: "auto",
      zIndex: "1",
      children: /*#__PURE__*/_jsx(Tabs, {
        selected: selected,
        use: "enclosed",
        display: "flex",
        justifyContent: "center",
        bordered: false,
        children: tabs.map(tab => {
          return /*#__PURE__*/_jsx(Tab, {
            tabId: tab,
            title: /*#__PURE__*/_jsx(FormattedMessage, {
              message: `pricingPage.pages.products.tabs.${tab}.tabTitle`
            }),
            onClick: () => handleTabChange(tab),
            "data-selenium-id": `nav-item-tabs-${tab}-tab`
          }, tab);
        })
      })
    })
  );
};
export default NavItemTabs;